import { MouseEventHandler } from 'react';

import { HistoryIcon, TrashIcon } from '@assets/icons';
import CustomIcon from '@components/utils/CustomIcon/index';

import {
  ClearSearchButton,
  StyledSearchContainer,
  Text,
  TextContainer,
} from './styled';

interface PastSearchesHeaderProps {
  onClearClick?: MouseEventHandler<HTMLButtonElement> | undefined;
}
export const PastSearchesHeader = ({
  onClearClick,
}: PastSearchesHeaderProps) => (
  <StyledSearchContainer>
    <TextContainer>
      <span>
        <CustomIcon paletteColor='coral' fontSize={24} icon={HistoryIcon} />
      </span>
      <Text color='coral'>Geçmiş Aramalarım</Text>
    </TextContainer>
    <TextContainer>
      <ClearSearchButton onClick={onClearClick}>
        <CustomIcon
          paletteColor='brownishGrey'
          fontSize={20}
          icon={TrashIcon}
        />
      </ClearSearchButton>
    </TextContainer>
  </StyledSearchContainer>
);
